import { NgModule } from '@angular/core';
import { MathTextComponent } from './components/math-text/math-text.component';
import { MathTextWrapperComponent } from './components/math-text-wrapper/math-text-wrapper.component';
import { MathToSpeechPipe } from './pipes/math-to-speech.pipe';
@NgModule({
  imports: [MathTextComponent, MathTextWrapperComponent, MathToSpeechPipe],
  exports: [MathTextComponent, MathTextWrapperComponent, MathToSpeechPipe],
})
export class MathTextModule {}
